import { useEffect, useRef, useState } from 'react';
import { supportAPI } from '../api';
import { useAuth } from '../context/AuthContext';

const POLL_INTERVAL_MS = 90 * 1000;

export function useUnreadMessages() {
  const { user, loading: authLoading } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const requestInFlightRef = useRef(false);

  const fetchUnreadCount = async () => {
    if (requestInFlightRef.current || document.hidden) return;
    if (!localStorage.getItem('nb_token')) return;

    try {
      requestInFlightRef.current = true;
      const res = await supportAPI.mine();
      const tickets = res.data.tickets || [];
      
      // Count messages from admins in open/pending tickets
      let count = 0;
      tickets.forEach(ticket => {
        if (ticket.status !== 'resolved') {
          ticket.messages?.forEach(message => {
            if (message.sender_role === 'admin' || message.sender_role === 'super_admin') {
              count++;
            }
          });
        }
      });
      
      setUnreadCount(count);
    } catch (err) {
      if (err.response?.status !== 401) {
        console.error('Failed to fetch unread messages:', err);
      }
    } finally {
      setLoading(false);
      requestInFlightRef.current = false;
    }
  };

  useEffect(() => {
    if (authLoading) {
      return undefined;
    }

    if (!user) {
      setUnreadCount(0);
      setLoading(false);
      return undefined;
    }

    fetchUnreadCount();
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        fetchUnreadCount();
      }
    };
    const interval = setInterval(fetchUnreadCount, POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [authLoading, user]);

  return { unreadCount, loading };
}
